module.exports = __webpack_public_path__ + "img/wp-new-habit-card3.3c0bd35a.jpg";